
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Outbid = class Notification_Outbid {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _outbid_modal_init = false;
    static _outbid_modal_action = null;

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let meta;
        let bid_id = null;

        try {
            meta = JSON.parse(this.notification.meta)
            if (meta.bid_id) {
                bid_id = meta.bid_id;
            }

        } catch (e) {
        }

        // Called when we receive a message from the server that the user has been outbid on an item in this auction.
        // This is a notification - when the function returns, we will assume the notification has been satasfied.
        // So don't return the notification until we are done with the prompt.

        // See await _.Modal.pick().  Used for editing a pending bid.  may work better.

        // Button handlers.
        if (!_.Notification_Outbid._outbid_modal_init) {
            _.Notification_Outbid._outbid_modal_init = true;
            $("#ac-modal-outbid-btn-bid-ask").click(function () {
                _.Notification_Outbid._outbid_modal_action = 'ask';
                _.Modal.close_unhidable({ hide_overlay: false });
            });
            $("#ac-modal-outbid-btn-bid-custom").click(function () {
                _.Notification_Outbid._outbid_modal_action = 'custom';
                _.Modal.close_unhidable({ hide_overlay: false });
            });
            $("#ac-modal-outbid-btn-close").click(function () {
                _.Modal.close_unhidable();
            });
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {
                // do {
                _.Notification_Outbid._outbid_modal_action = null;

                let my_bid = await App_Models_Bid.get_private(bid_id);

                if (!my_bid) {
                    _.shouldnt_happen();
                    return;
                }

                let is_tie_bid =
                    my_bid.status == App_Models_Bid.STATUS_OUTBID_TIE;

                let auction_round_id = my_bid.auction_round_id;
                let auction_round = await App_Models_AuctionRound.get_private(auction_round_id);

                // Bid can be deleted if it was a pending bid before it was outbid
                if (!auction_round) {
                    resolve();
                    return;
                }

                let high_bid = await auction_round.current_bid.fetch_private();
                let high_bid_amount = auction_round.current_bid_amount;
                let ask = auction_round.current_bid_amount + auction_round.increment;

                if (high_bid && high_bid.registrant_id == (_.ac_state ? _.ac_state.registrant.id : null)) {
                    // We're the current high bidder, this notification is obsolete.
                    resolve();
                    return;
                }

                $(".ac-modal-outbid-standard-item-title").text()

                $(".ac-modal-outbid-mybid").text(_.currency(my_bid.amount));

                let update_outbid_notification_amounts = async function () {
                    high_bid_amount = auction_round.current_bid_amount;
                    $("#ac-modal-outbid-current-bid").text(_.currency(high_bid_amount));
                    ask = auction_round.ask;
                    $("#ac-modal-outbid-ask-price").text(_.currency(ask));
                }

                if (is_tie_bid) {
                    $(".ac-modal-outbid-standard-wording").hide();
                    $(".ac-modal-outbid-tie-wording").show();
                } else {
                    $(".ac-modal-outbid-standard-wording").show();
                    $(".ac-modal-outbid-tie-wording").hide();
                }

                self.auction_round_subscription = await auction_round.subscribe(true, update_outbid_notification_amounts);

                let deferred = $.Deferred();

                $("#ac-modal-outbid").data('deferred', deferred);

                if (_.AuctionUI.auction_is_standard_or_enterprise()) {
                    let item = await auction_round.auction_item.fetch_private();
                    $("#ac-modal-outbid-item").text(item.title);
                } else if (_.AuctionUI.auction_is_choice()) {
                    let auction = await auction_round.auction.fetch_private();
                    let property = await auction.property.fetch_private();
                    $("#ac-modal-outbid-item").text(property.title + " - Round " + auction_round.round_number);
                }

                if (high_bid && high_bid.paddle_number) {
                    $(".ac-modal-outbid-who-did-it").html(" by <strong>[" + high_bid.paddle_number + "]</strong>");
                } else {
                    $(".ac-modal-outbid-who-did-it").text("");
                }

                $("#ac-modal-outbid").modal_show();

                // Wait for the modal to close.
                await deferred.promise();

                // Do things
                try {
                    self.auction_round_subscription.unsubscribe();
                } catch (e) { }

                // If they clicked a relevant button, handle it
                let item = null;
                let item_id = null;
                if (_.AuctionUI.auction_is_standard_or_enterprise()) {
                    item = await auction_round.auction_item.fetch_private();
                    if (item) {
                        item_id = item.id;
                    }
                }

                if (_.Notification_Outbid._outbid_modal_action == 'ask') {
                    await _.AuctionUI_Bids.try_bid(item_id, ask);
                } else if (_.Notification_Outbid._outbid_modal_action == 'custom') {
                    await _.AuctionUI_Bids.custom_bid_modal(item_id);
                }

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
        try {
            self.auction_round_subscription.unsubscribe();
        } catch (e) { }
    }
}